import { render, staticRenderFns } from "./StudentsGradeWorkList.vue?vue&type=template&id=4b556ff2&scoped=true&"
import script from "./StudentsGradeWorkList.vue?vue&type=script&lang=js&"
export * from "./StudentsGradeWorkList.vue?vue&type=script&lang=js&"
import style0 from "./StudentsGradeWorkList.vue?vue&type=style&index=0&id=4b556ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b556ff2",
  null
  
)

export default component.exports